/**
 * Helpers for displaying web search grounding sources in the chat UI.
 */

import type { GroundingSource } from "./types";

const REDIRECT_HOSTS = ["vertexaisearch.cloud.google.com", "google.com"];

/** Title is often the hostname when Gemini returns a grounding redirect URI. */
const DOMAIN_TITLE_RE = /^[\w-]+(\.[\w-]+)+$/i;

export function getSourceDomain(source: GroundingSource): string {
  if (source.domain) return source.domain.replace(/^www\./, "");

  const title = source.title.trim();
  if (DOMAIN_TITLE_RE.test(title)) {
    return title.replace(/^www\./, "");
  }

  try {
    const host = new URL(source.uri).hostname.replace(/^www\./, "");
    if (!REDIRECT_HOSTS.some((redirect) => host === redirect || host.endsWith(`.${redirect}`))) {
      return host;
    }
  } catch {
    // fall through
  }

  return title || source.uri;
}

export function getSiteLabel(domain: string): string {
  return domain.replace(/^www\./, "");
}

/** e.g. "wesele.pro" or "wesele.pro +10" */
export function formatSourceBadgeLabel(sources: GroundingSource[]): string {
  const primary = getSiteLabel(getSourceDomain(sources[0]!));
  if (sources.length <= 1) return primary;
  return `${primary} +${sources.length - 1}`;
}

export function getFaviconUrl(domain: string, size = 32): string {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
}

export function isRedirectHost(domain: string): boolean {
  return REDIRECT_HOSTS.some((redirect) => domain === redirect || domain.endsWith(`.${redirect}`));
}
